import constants from '../constants/index';

const defaultState = [];

export default function errors(state = defaultState, action) {
  let newState = state;

  switch(action.type) {
    case constants.REQUEST_AUTHENTICATION_FAIL:
    case constants.REQUEST_SCHEDULES_FAIL:
    case constants.REQUEST_SCHEDULE_FAIL:
      newState = [action.payload];
      break;
    default:
  }
  return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/errors_reducer.js
 **/